module.exports = __webpack_public_path__ + "static/media/WZ7.f07b22bd.jpg";